import { QueryClient } from '@tanstack/react-query'

// One QueryClient instance for the app. Unlike the admin console, coaches
// open this on a phone in short bursts (check the roster, set jersey numbers,
// pull a game card) so keep data reasonably fresh but still avoid refetch
// storms on window focus (mobile browsers fire focus events aggressively on
// app-switch).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s
      gcTime: 5 * 60_000, // 5 min in memory
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})

/** The coach-facing list queries that a jersey-save (or any future roster
 *  mutation) can affect. Kept in one place so every mutation's onSuccess
 *  invalidates the same set. */
export function invalidateCoachLists(qc: QueryClient): void {
  for (const key of [['teams'], ['roster']]) void qc.invalidateQueries({ queryKey: key })
}
